document.addEventListener('DOMContentLoaded', function() {
  const form = document.getElementById('wholesale-quick-order');
  const errorBanner = document.getElementById('wholesale-error-message');
  
  if (!form) return;

  // Extract Liquid configuration values from form dataset attributes
  const minRequired = parseInt(form.dataset.minRequired, 10) || 10;
  const cartAction = form.dataset.cartAction || 'checkout';
  const cartUrl = form.dataset.cartUrl || '/cart';
  const submitButton = form.querySelector('button[type="submit"]');

  if (!submitButton) return;

  form.addEventListener('submit', async function(e) {
    e.preventDefault();

    let pageQty = 0;
    let stockError = false;
    let stockErrorMessage = '';
    const updates = {};

    const inputs = form.querySelectorAll('.wholesale-qty-input');

    inputs.forEach(input => {
      const qty = parseInt(input.value, 10) || 0;
      const maxStockAttr = input.getAttribute('data-max-stock');
      const variantTitle = input.getAttribute('data-variant-title') || 'Selected item';
      
      const variantIdMatch = input.name.match(/\[(.*?)\]/);
      if (variantIdMatch && variantIdMatch[1]) {
        const variantId = variantIdMatch[1];
        if (qty > 0) {
          updates[variantId] = qty;
        }
      }

      pageQty += qty;

      if (maxStockAttr !== null) {
        const maxStock = parseInt(maxStockAttr, 10);
        if (qty > maxStock) {
          stockError = true;
          stockErrorMessage = `Cannot add ${qty} units of "${variantTitle}". Only ${maxStock} remaining in stock.`;
        }
      }
    });

    if (stockError) {
      errorBanner.innerText = stockErrorMessage;
      errorBanner.style.display = 'block';
      errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const originalBtnText = submitButton.innerText;
    submitButton.disabled = true;
    submitButton.innerText = 'Processing Order...';

    try {
      const cartResponse = await fetch('/cart.js');
      const currentCart = await cartResponse.json();
      const existingCartQty = currentCart.item_count || 0;

      if (currentCart.items && currentCart.items.length > 0) {
        currentCart.items.forEach(item => {
          if (updates[item.variant_id]) {
            updates[item.variant_id] += item.quantity;
          } else {
            updates[item.variant_id] = item.quantity;
          }
        });
      }

      const combinedTotal = pageQty + existingCartQty;

      if (combinedTotal < minRequired) {
        submitButton.disabled = false;
        submitButton.innerText = originalBtnText;

        if (existingCartQty > 0) {
          errorBanner.innerText = `Wholesale minimum requirement is ${minRequired} items. You have ${existingCartQty} item(s) in your cart and ${pageQty} selected here (${combinedTotal} total).`;
        } else {
          errorBanner.innerText = `Wholesale minimum requirement is ${minRequired} items. You currently have ${pageQty} items selected.`;
        }

        errorBanner.style.display = 'block';
        errorBanner.scrollIntoView({ behavior: 'smooth', block: 'center' });
        return;
      }

      const updateResponse = await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });

      if (updateResponse.ok) {
        if (cartAction === 'cart') {
          window.location.href = cartUrl;
        } else {
          window.location.href = '/checkout';
        }
      } else {
        throw new Error('Failed to update cart');
      }

    } catch (err) {
      console.error(err);
      submitButton.disabled = false;
      submitButton.innerText = originalBtnText;
      errorBanner.innerText = 'There was an issue processing your cart. Please try again.';
      errorBanner.style.display = 'block';
    }
  });
});